import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { platformApi } from '../api/endpoints/platform';
import { adminAssignmentScopeName } from '../lib/scopeLabels';
import { UNKNOWN_ROLE } from '../lib/labelConstants';
import { useRoleNameById } from './useRoleNameById';

export interface AdminAssignmentLabels {
    roleName(roleId: string): string;
    scopeName(scopeRef: string): string;
}

/** Nombres del rol y del alcance de las asignaciones de un administrador de plataforma. */
export function useAdminAssignmentLabels(enabled: boolean): AdminAssignmentLabels {
    const roleNameById = useRoleNameById();
    const { data: tenantsData } = useQuery({
        queryKey: ['platform', 'tenants'],
        queryFn: () => platformApi.listTenants(),
        enabled,
    });

    return useMemo(() => {
        const tenantNameById = new Map(
            (tenantsData?.items ?? []).map((t) => [t.tenantId, t.displayName]),
        );
        return {
            roleName: (roleId) => roleNameById.get(roleId) ?? UNKNOWN_ROLE,
            scopeName: (scopeRef) =>
                adminAssignmentScopeName(scopeRef, tenantNameById.get(scopeRef)),
        };
    }, [roleNameById, tenantsData]);
}
